<script>
export default {
    name: 'MoveRepsSlideItem',
    props: ['item']
}
</script>

<style scoped>
    .main-wrap{
        height: 100vh;
        position: relative;
    }
    .order{
        left: 0;
        top: 0;
        position: absolute;
    }
    .order h2{
        color: #fff;
    }
    .wrap{
        max-width: 80vw;
    }
    .content{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh
    }
    .content h1{
        color: #fff;
    }
    .countdown{
        background-color: #469a2e;
        width: 20vw;
        position: absolute;
        bottom: 0;
        left: 40vw;
        height: 30vh;
    }
    .countdown h1{
        color: #000;
        font-size: 12rem;
    }
</style>

<template>
    <div class="main-wrap">
        <div class="order">
            <h2>{{item.order}}</h2>
        </div>
        <div class="content">
            <div class="wrap">
                <h1>{{item.title}}</h1>
            </div>
        </div>
        <div class="countdown">
            <h1>
                {{item.countdown}}
            </h1>
        </div>
    </div>

</template>